import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullTransform',
})
export class NullTransformPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return value ? value : 'N/A';
  }
}
